module.exports = __webpack_public_path__ + "static/media/question.e922d2b3.svg";